import * as _ from 'lodash';
// TODO: Finish billing code validation
// import ErrorResponse from 'src/models/ErrorResponse';
import React, { useEffect, useState } from 'react';
// import State from 'src/models/State';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import ReceiptDocs from './ReceiptDocs';
import Voucher from 'src/models/AP/VoucherMaintenanceForm';
import { ExpenseType } from 'src/models/AP/ExpenseType';
import Expense from 'src/models/AP/Expense';
import * as Constants from 'src/components/common/Constants';
import ChargeIndividual from 'src/models/AP/ChargeIndividual';
import moment from 'moment';
import VoucherMaintenanceForm from 'src/models/AP/VoucherMaintenanceForm';
import DefineBudgetCategoryDialog from '../dialogs/DefineBudgetCategoryDialog';
import FindVendorDialog from '../dialogs/FindVendorDialog';
import AddVendorInvoicesDialog from '../dialogs/AddVendorInvoicesDialog';
import PagedResultSet from 'src/models/common/PagedResultSet';
import AccountInfo from 'src/models/AP/AccountInfo';
import VoucherReceipt from 'src/models/AP/VoucherReceipts';
import Personnel from 'src/models/personnel/Personnel';
import FindPersonDialog from '../dialogs/FindPersonDialog';
import WarningDialog from '../dialogs/WarningDialog';
import ReportOptionsDialog from '../dialogs/ReportOptionsDialog';
import FindAvailableAccountsDialog from '../dialogs/FindAvailableAccountsDialog';
// icons
import { BiReceipt, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaLock, FaPrint, FaRegSave, FaPlusCircle, FaRegFileExcel, FaMoneyCheckAlt, FaFileInvoiceDollar } from 'react-icons/fa';
import { BsLightningFill } from 'react-icons/bs';
import { GiQuillInk } from 'react-icons/gi';
import { /*IoMdExit,*/ IoMdCloseCircleOutline } from 'react-icons/io';
import { MdDoNotDisturb } from 'react-icons/md';
import { VscGraph } from 'react-icons/vsc';
import ChooseVouchersDialog from '../dialogs/ChooseVouchersDialog';
import ExcelFileDialog from '../dialogs/ExcelFileDialog';
import EnterCheckNumberDialog from '../dialogs/EnterCheckNumberDialog';
import CreateCheckWarningDialog from '../dialogs/CreateCheckWarningDialog';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import Vendor from 'src/models/AP/Vendor';
// import Account from 'src/models/Account';
import VoidVoucherDialog from '../dialogs/VoidVoucherDialog';
import OutputDestinationDialog from '../dialogs/OutputDestinationDialog';
import LedgerAccount from 'src/models/AP/GeneralLedgerAccount';
import VendorInvoice from 'src/models/AP/VendorInvoice'; 
import AddVendorExDialog from '../dialogs/AddVendorExDialog';
import { ITableConfig } from 'src/components/common/table';
import APNavBar from '../APNavBar';

const VouchersPage = () => {
    const dispatch = useDispatch();
    const { get, post, del, put, response } = useFetch();
    const { register, reset, setValue, getValues, handleSubmit, errors, formState } = useForm();
    const [voucherIndex, setVoucherIndex] = useState<number>(-1);
    const [invoiceAmount, setInvoiceAmount] = useState<number>(0);
    const [voucherCheckNumber, setVoucherCheckNumber] = useState<number>(0);
    const [voucherCheckDate, setVoucherCheckDate] = useState<string>(undefined);
    const [voucherInvoices, setVoucherInvoices] = useState<Array<VendorInvoice>>(undefined);
    const [selectedEmployeePay, setSelectedEmployeePay] = useState(undefined);
    const [vouchers, setVouchers] = useState<PagedResultSet<Voucher>>(undefined);
    const [voucherAccounts, setVoucherAccounts] = useState<Array<Expense>>(undefined);
    const [uncommittedVoucherAccounts, setUncommittedVoucherAccounts] = useState<Array<Expense>>(undefined);
    const [newInvoices, setNewInvoices] = useState<Array<VendorInvoice>>(undefined);
    const [triggerHideDialog, setTriggerHideDialog] = useState<Object>(undefined);
    const [voucherReceipts, setVoucherReceipts] = useState<PagedResultSet<VoucherReceipt>>(undefined);
    const [chargeIndividuals, setChargeIndividuals] = useState<Array<ChargeIndividual>>(undefined);
    const [allChargeIndividuals, setAllChargeIndividuals] = useState<Array<ChargeIndividual>>(undefined);
    const [accountInfo, setAccountInfo] = useState<AccountInfo>(undefined);
    // const [clients, setClients] = useState<Array<object>>(undefined);
    const [voidingVoucher, setVoidingVoucher] = useState<boolean>(false);
    const [addingJustInvoices, setAddingJustInvoices] = useState<boolean>(false);
    const [currentVoucherMaintenanceForm, setCurrentVoucherMaintenanceForm] = useState<VoucherMaintenanceForm>(undefined);
    const [selectedVoucherAccountIndex, setSelectedVoucherAccountIndex] = useState<number>(0);
    const [selectedVendorIndex, setSelectedVendorIndex] = useState<number>(-1);
    // const [voucherExpenses, setVoucherExpenses] = useState<Voucher[]>([]);
    // const [expenses, setExpenses] = useState<Expense[]>(undefined);
    const [selectedExpense, setSelectedExpense] = useState<Expense>(undefined);
    const [selectedLedgerAccount, setSelectedLedgerAccount] = useState<LedgerAccount>(undefined);
    const [vendorInvoiceFieldContent, setVendorInvoiceFieldContent] = useState<string>('');
    const [vendorSearchOptions, setVendorSearchOptions] = useState<ODataOptions>(undefined);
    const [voucherSearchOptions, setVoucherSearchOptions] = useState<ODataOptions>(undefined);
    const [vendorSearchTerm, setVendorSearchTerm] = useState<string>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const [fetchNextVouchersPage, setFetchNextVouchersPage] = useState<boolean>(true);
    const [newVoucher, setNewVoucher] = useState<boolean>(false);
    const [selectedExpenseIndex, setSelectedExpenseIndex] = useState<number>(undefined);
    const [selectedIndividualIndex, setSelectedIndividualIndex] = useState<number>(-1);
    const [vendors, setVendors] = useState<PagedResultSet<Vendor>>(undefined);
    const [selectedVendor, setSelectedVendor] = useState<Vendor>(undefined);
    const [billingAccounts, setBillingAccounts] = useState<{ code: number, description: string}[]>([]);
    const [voidType, setVoidType] = useState<'Voucher' | 'Check'>(undefined);
    const { isDirty, dirtyFields } = formState;
    // TODO: Finish billing code validation
    // const [timeAndExpenseToken, setTimeAndExpenseToken] = useState<string>('');
    // const [clientValidations, setClientValidations] = useState<Array<boolean>>([]);

    const voucherMaintenanceForm: VoucherMaintenanceForm = {  
        voucherId: 1,
        voucherNumber: '38730',
        reoccuranceNumber: 1,
        vendorNumber: 1,
        vendorInvoice: '',
        vendorId: 1,
        vendorName: 'FedEx',
        invoiceNumber: 2128, 
        invoiceDate: null, 
        voucherAmount: 22.64,
        invoiceAmount: 22.64,
        dueDate: null,
        closeDate: null, 
        approvalDate: null,
        checkNumber: 7182024, 
        checkDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date,
        checkVoidDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date,
        paymentStatus: 'Paid',
        isCheckVoid: true,
        checkVoidState: false,
        isVoucherVoid: true,
        dateCheckVoided: null,
        dateVoucherVoided: null,
        description: 'Description',
        reoccurNumber: 0,
        paymentNumber: 7,
        voucherAccountId: 0,

        voucherExpenses: [
            {id: 1, accountId: 1, voucherId: 1, accountNumber: '2-5-07-115-0000-8', accountDescriptor: 'REIM. EXP - SHIPPING EXPENSES', amount: 8.09,
                description: '', projectNumber: 460, clientNumber: 280, sectionNumber: 22, unitNumber: null, billingAccount: 'Lease Acqusition', 
                expenseType: ExpenseType.Shipping_Expense, budgetCategoryName: 'category', budgetSubcategoryName: 'subcategory'
             },
            {id: 2, accountId: 2, voucherId: 2, accountNumber: '2-5-07-115-0000-8', accountDescriptor: 'REIM. EXP - SHIPPING EXPENSES', amount: 33.07,
                description: '', projectNumber: 460, clientNumber: 280, sectionNumber: 171, unitNumber: null, billingAccount: 'Lease Acqusition', 
                expenseType: ExpenseType.Shipping_Expense, budgetCategoryName: 'category', budgetSubcategoryName: 'subcategory'
             },
            {id: 3, accountId: 3, voucherId: 3, accountNumber: '2-5-07-115-0000-8', accountDescriptor: 'REIM. EXP - SHIPPING EXPENSES', amount: 8.08,
                description: '', projectNumber: 460, clientNumber: 280, sectionNumber: 179, unitNumber: null, billingAccount: 'Lease Acqusition', 
                expenseType: ExpenseType.Shipping_Expense, budgetCategoryName: 'category', budgetSubcategoryName: 'subcategory'
             },
            {id: 4, accountId: 4, voucherId: 4, accountNumber: '2-5-07-115-0000-8', accountDescriptor: 'REIM. EXP - SHIPPING EXPENSES', amount: 15.15,
                description: '', projectNumber: 460, clientNumber: 279, sectionNumber: 111, unitNumber: null, billingAccount: 'Lease Acqusition', 
                expenseType: ExpenseType.Shipping_Expense, budgetCategoryName: 'category', budgetSubcategoryName: 'subcategory'
             },
            {id: 5, accountId: 5, voucherId: 5, accountNumber: '2-5-07-115-0000-8', accountDescriptor: 'REIM. EXP - SHIPPING EXPENSES', amount: 15.14,
                description: '', projectNumber: 460, clientNumber: 280, sectionNumber: 179, unitNumber: null, billingAccount: 'Lease Acqusition', 
                expenseType: ExpenseType.Shipping_Expense, budgetCategoryName: 'category', budgetSubcategoryName: 'subcategory'
             },
            {id: 6, accountId: 6, voucherId: 6, accountNumber: '2-5-07-115-0000-8', accountDescriptor: 'REIM. EXP - SHIPPING EXPENSES', amount: 22.25,
                description: '', projectNumber: 1352, clientNumber: 1, sectionNumber: 3, unitNumber: null, billingAccount: 'Lease Acqusition', 
                expenseType: ExpenseType.Shipping_Expense, budgetCategoryName: 'category', budgetSubcategoryName: 'subcategory'
             },
        ], 
        chargeIndividual: [
            {
                id: 1,
                personType: 'Type',
                clientNumber: 31,
                clientName: 'Client Name',
                clientCity: 'OKC',
                clientState: 'OK',
                lmNo: 72,
                firstName: 'Bob',
                lastName: 'Cratchett',
                creditCardDetailId: null,
                voucherAccountId: null
            },
            {
                id: 2,
                personType: 'Type',
                clientNumber: 31,
                clientName: 'Client Name',
                clientCity: 'OKC',
                clientState: 'OK',
                lmNo: 72,
                firstName: 'Bob',
                lastName: 'Cratchett',
                creditCardDetailId: null,
                voucherAccountId: null
            },
            {
                id: 3,
                personType: 'Type',
                clientNumber: 31,
                clientName: 'Client Name',
                clientCity: 'OKC',
                clientState: 'OK',
                lmNo: 72,
                firstName: 'Bob',
                lastName: 'Cratchett',
                creditCardDetailId: null,
                voucherAccountId: null
            },
        ],
        accountInfo: {
            id: 2,
            client: 'Dudley Land Company',
            clientName: 'Dudley Land Company',
            clientNumber: 1,
            project: 'Oklahoma Office',
            projectName: 'Oklahoma Office',
            projectNumber: 1,
            prospect: null,
            sectionNumber: 3,
            sectionName: '',
            unitNumber: null,
            unitName: '',
            billingAccount: 'Lease Acquisition',
            glAccount: '2-5-07-115-0000-8',
        }
    };

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    // Add actions to perform when the vouchers list is populated
    useEffect(() => {
        if (!!vouchers && vouchers?.items.length > 0) {
            // getAccountInfo(vouchers?.items[0]?.voucherNumber, voucherAccounts[selectedVoucherAccountIndex]?.accountNumber);
            setVoucherIndex(999);
            console.log('Voucher list retrieved!');
            getVoucherAccounts(vouchers?.items[0].voucherNumber);
            getVoucherReceipts(vouchers?.items[0].voucherNumber);
            getChargeIndividuals(vouchers?.items[0].voucherNumber);
            getVoucherInvoices(vouchers?.items[0].voucherNumber);
        }
    }, [vouchers]);

    useEffect(() => {
        if (voucherIndex === 999) {
            setVoucherIndex(0);
        } else if (voucherIndex > -1 && !!vouchers && vouchers?.items.length >= voucherIndex) {
            populateVoucherData(voucherIndex);
        }
    }, [voucherIndex]);

    useEffect(() => {
        if (!!selectedLedgerAccount) {
            addUncommittedVoucherAccount(selectedLedgerAccount);
        }
    }, [selectedLedgerAccount]);

    // TODO: Finish billing code validation
/*     useEffect(() => {
        if (!!clientValidations && clientValidations.length > 0) {
            const invalidClient = clientValidations.find(e => e === false);
            if (invalidClient === undefined) {
                onClientsValidated();
            }
        }
    }, [clientValidations]); */

    useEffect(() => {
        if (!!uncommittedVoucherAccounts && uncommittedVoucherAccounts.length > 0) {
            addLocalVoucherAccount();
        }
    }, [uncommittedVoucherAccounts]);

    useEffect(() => {
        if (!!triggerHideDialog) {
            hideDialog();
        } else {
            setTriggerHideDialog(undefined);
        }
    },  [triggerHideDialog]);

    useEffect(() => {
        if (selectedVendorIndex > -1 && !!vendors) {
            let newVendor = _.cloneDeep(vendors?.items[selectedVendorIndex]);
            setSelectedVendor(newVendor);
        }
    }, [selectedVendorIndex]);

    useEffect(() => {
        if (!!selectedVendor) {
            setVoucherAccounts([]);
        }
    }, [selectedVendor]);

    useEffect(() => {
        if (!!vendorSearchTerm || vendorSearchTerm === '') {
            // vendors.items = [];
            // setVendors(vendors);
            resetVendorSearchOptions();
        }
    }, [vendorSearchTerm]);

    useEffect(() => {
        if (!!voucherInvoices && voucherInvoices?.length >= 1) {
            getVendorInvoiceFieldContent();
            getVendorInvoiceAmountFieldContent();
        } else {
            // setValue('voucherMaintenanceForm.vendorInvoice', '');
            // setValue('voucherMaintenanceForm.invoiceAmount', '');
            voucherMaintenanceForm.vendorInvoice = '';
            voucherMaintenanceForm.invoiceAmount = 0;
            // reset(voucherMaintenanceForm);
            setValue('voucherMaintenanceForm.invoiceAmount', '');
            getVendorInvoiceFieldContent();
            getVendorInvoiceAmountFieldContent();
        }
    }, [voucherInvoices]);

    useEffect(() => {
        // normalizeBlankRows();
        if (!!voucherAccounts && voucherAccounts?.length > 0 && !!vouchers && vouchers?.items?.length > 0) {
            calculateTotal();
            // setClientValidations(new Array<boolean>(voucherAccounts?.length).fill(true));

            // index 3 is the 1st non-blank entry. 99000 - 100000 means it's a blank entry. > 100000 means it's a new unsaved entry.
            if (voucherAccounts.length > 3 && voucherAccounts[3]?.accountId < Constants.accountsPayableVoucherAccountsBlankAccountsBase) {
                getAccountInfo(vouchers?.items[voucherIndex]?.voucherNumber, voucherAccounts[3]?.accountNumber);
            }
/*             voucherAccounts.forEach((va, index) => {
                if (!!va?.clientNumber && va?.accountId >= Constants.accountsPayableVoucherAccountsUnsavedAccountsBase) {
                    getClient(voucherAccounts[index].clientNumber, index);
                }
            }); */
        }
    }, [voucherAccounts]);

    useEffect(() => {
        if (!!voucherInvoices && voucherInvoices?.length > 0) {
            if (!!vouchers && !!vouchers.items[voucherIndex]?.vendorNumber) {
                voucherInvoices[0].vendorNumber = vouchers.items[voucherIndex]?.vendorNumber.toString();
            }
        }
    }, [voucherInvoices]);

    useEffect(() => {
        if (!!vendorSearchOptions) {
            getVendors(!!vendorSearchTerm ? vendorSearchTerm : '');
        }
    }, [vendorSearchOptions]);

    // TODO: Finish billing code validation
/*     useEffect(() => {
        if (!!timeAndExpenseToken && timeAndExpenseToken.length > 0) {
            console.log(timeAndExpenseToken);
        }
    }, [timeAndExpenseToken]); */

    useEffect(() => {
        if (!!addingJustInvoices) {
            dispatch(actions.layout.showDialog(DialogList.ADD_VENDOR_INVOICES));
        }
    }, [addingJustInvoices]);

    useEffect(() => {
        if (!!voucherSearchOptions) {
            getVouchers();
        }
    }, [voucherSearchOptions]);

    // SelectedEmployeePay changes on Update Pay
    useEffect(() => {
        console.log('resetting the form');
        reset(initializeData(selectedEmployeePay));
    }, [selectedEmployeePay]);

    useEffect(() => {
        if (newInvoices && newVoucher) {
            prepareVoucherForm(newInvoices);
        }
    }, [newInvoices]);

/*     const normalizeBlankRows = () => {
        if (!!voucherAccounts && voucherAccounts?.length > 0) {
            let nonBlankRows = voucherAccounts.filter(va =>
                va?.accountNumber !== undefined
                );
            if (voucherAccounts.length > nonBlankRows.length + 3) {
                nonBlankRows = [...nonBlankRows.concat(getBlankExpenseRows(3))];
                setVoucherAccounts(nonBlankRows);
            }
        }
    }; */

    const initializeVendorSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 50,
            idField: 'VNDR_NO',
            pageNumber: 1,
            columns: []
        };
        setVendorSearchOptions(ODataOptions.from(tableConfig).addOrderBy('VendorName', ODataOrderByDirection.Ascending));
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setBillingAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const initializeVoucherSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 50,
            idField: 'VCHR_NO',
            pageNumber: 1,
            columns: []
        };
        setVoucherSearchOptions(ODataOptions.from(tableConfig).addOrderBy('VoucherNumber', ODataOrderByDirection.Ascending));
    };

    const populateVoucherData = (selectedVoucherIndex: number) => {
        if (!!vouchers && vouchers?.items?.length >= voucherIndex) {
            let newVoucherData = new VoucherMaintenanceForm();
            newVoucherData.vendorId = !!vouchers?.items[selectedVoucherIndex]?.vendorNumber ? vouchers?.items[selectedVoucherIndex]?.vendorNumber : 0;
            newVoucherData.voucherId = !!vouchers?.items[selectedVoucherIndex]?.voucherNumber ? Number(vouchers?.items[selectedVoucherIndex]?.voucherNumber) : 0;
            newVoucherData.voucherNumber = !!vouchers?.items[selectedVoucherIndex]?.voucherNumber ? vouchers?.items[selectedVoucherIndex]?.voucherNumber : '';
            newVoucherData.vendorName = vouchers.items[selectedVoucherIndex]?.vendorName;
            newVoucherData.invoiceDate = vouchers.items[selectedVoucherIndex].invoiceDate;
            newVoucherData.dueDate = vouchers.items[selectedVoucherIndex].dueDate;
            newVoucherData.closeDate = vouchers.items[selectedVoucherIndex].closeDate;
            newVoucherData.vendorInvoice = vouchers.items[selectedVoucherIndex].vendorInvoice;
            newVoucherData.voucherAmount = vouchers.items[selectedVoucherIndex].voucherAmount;
            newVoucherData.invoiceAmount = vouchers.items[selectedVoucherIndex].invoiceAmount;
            newVoucherData.description = vouchers.items[selectedVoucherIndex].description;
            newVoucherData.isVoucherVoid = vouchers.items[selectedVoucherIndex].isVoucherVoid;
            newVoucherData.isCheckVoid = vouchers.items[selectedVoucherIndex].isCheckVoid;
            newVoucherData.checkVoidDate = vouchers.items[selectedVoucherIndex].checkVoidDate;
            newVoucherData.dateVoucherVoided = vouchers.items[selectedVoucherIndex].dateVoucherVoided;
            newVoucherData.paymentNumber = vouchers.items[selectedVoucherIndex].paymentNumber;
            newVoucherData.checkNumber = vouchers.items[selectedVoucherIndex].checkNumber;
            newVoucherData.checkDate = vouchers.items[selectedVoucherIndex].checkDate;
            setCurrentVoucherMaintenanceForm(newVoucherData);
            setVoucherIndex(selectedVoucherIndex);
        }
    };

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('VouchersPage onCreate()');
        // getClients();
        getBillingAccounts();
        getPersonnelEmployeePay();
        initializeVoucherSearchSettings();
        initializeVendorSearchSettings();
        setCurrentVoucherMaintenanceForm(voucherMaintenanceForm);
        // TODO: Finish billing code validation
        // getTEUserToken();
        // getPersonnelBilling();
        // setExpenses(voucherMaintenanceForm?.voucherExpenses);
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('VouchersPage onDestroy()');
    };

    const showAddVendorDialog = () => {
        showDialog(DialogList.ADD_VENDOR_EX);
    };

    const hideAddVendorDialog = () => {
        hideDialog();
        showDialog(DialogList.FIND_VENDOR);
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const onCancel = () => {
        setNewVoucher(false);
        dispatch(actions.layout.hideDialog());
    };

    const onCancelAddVendorInvoiceDialog = () => {
        setAddingJustInvoices(false);
        dispatch(actions.layout.hideDialog());
    };

/*     const onHideAddVendorInvoicesDialog = () => {
        setNewVoucher(false);
        dispatch(actions.layout.hideDialog());
    }; */

    const hideDialogEx = () => {
        dispatch(actions.layout.hideDialog());
        if (selectedVendorIndex > -1) {
            if (!!newVoucher) {
                addVendorInvoices();
            } else {
                let newVoucherDataOptions = _.cloneDeep(voucherSearchOptions);
                newVoucherDataOptions?.clearFilters();
                newVoucherDataOptions?.addFilter(new ODataFilter('vchr.VNDR_NO', ODataFilterOperators.Equals, vendors?.items[selectedVendorIndex]?.vendorNumber));
                setVoucherSearchOptions(newVoucherDataOptions);
                setVendorSearchTerm('');
            }
        }
    };

    const hideAddVendorInvoiceDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    const hideFindLedgerAccountDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    const handleFindLedgerAccountOKClicked = (ledgerAccount: LedgerAccount) => {
        setSelectedLedgerAccount(ledgerAccount);
        dispatch(actions.layout.hideDialog());
    };

    const hideDialog = () => {
        if (!!newVoucher) {
            prepareVoucherForm(voucherInvoices);
        }
        setVoidingVoucher(false);
        setAddingJustInvoices(false);
        dispatch(actions.layout.hideDialog());
        if (!!newVoucher) {
            dispatch(actions.layout.showDialog(DialogList.ADD_VENDOR_INVOICES));
        }
    };

    const calculateTotal = () => {
        let formVoucherAccounts = getValues()?.voucherAccounts;
        let voucherAccountTotal = 0;
        if (formVoucherAccounts?.length) {
            for (let voucherAccountIndex = 0; voucherAccountIndex < voucherAccounts?.length; voucherAccountIndex++) {
                if (!!formVoucherAccounts[voucherAccountIndex]?.amount) {
                    voucherAccountTotal += parseFloat(formVoucherAccounts[voucherAccountIndex]?.amount + '');
                }
            }

            setValue('total', voucherAccountTotal);
            setValue('currentVoucherMaintenanceForm.voucherAmount', voucherAccountTotal);
        }
    };

    const getVoucherCheck = async (voucherNumber: number) => {

        const result = await get(`/v1.0/AccountsPayable/voucher/${voucherNumber}/check?voucherCheckNumber=${voucherCheckNumber}&voucherCheckDate=${voucherCheckDate}`);

        if (response.ok) {
            await response.blob().then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.getElementById(`a_voucherCheck`) as HTMLAnchorElement;
                a.href = blobUrl;
                a.download = `Voucher_${voucherNumber}_Check`;
                a.click();
                window.URL.revokeObjectURL(blobUrl);
            });
        } else {
            console.log('Unable to generate document.', result);
        }
    };

    const getVendorInvoiceFieldContent = () => {
        let csvFieldString = '';
        if (!!voucherInvoices && voucherInvoices.length > 0) {
            voucherInvoices?.map((vi) => {
                csvFieldString += vi.number;
                csvFieldString += ',';
            });
        }
        setVendorInvoiceFieldContent(csvFieldString.slice(0, -1));
        return csvFieldString.slice(0, -1);
    };

    const getVendorInvoiceAmountFieldContent = () => {
        let amountFieldValue = 0;
        if (!!voucherInvoices && voucherInvoices.length > 0) {
            voucherInvoices?.map((vi) => {
                amountFieldValue += vi.amount;
            });
        }
        setInvoiceAmount(amountFieldValue);
    };

    const defineBudgetCategory = (expense: Expense, index: number) => {
        setSelectedExpense(expense);
        setSelectedExpenseIndex(index);
        dispatch(actions.layout.showDialog(DialogList.DEFINE_BUDGET_CATEGORY));
    };

    const handleCategories = (category: string, subcategory: string) => {
        console.log('Define Budget Category Selections: ', category, subcategory);
        selectedExpense.budgetCategoryName = category;
        selectedExpense.budgetSubcategoryName = subcategory;

        if (selectedExpenseIndex !== null) {
            voucherMaintenanceForm.voucherExpenses[selectedExpenseIndex] = selectedExpense;
        }

        // setExpenses(voucherMaintenanceForm.voucherExpenses);
        // setSelectedExpense(modifiedExpense);
    };

    const handleReport = (category: string, subcategory: string) => {
        console.log('Define Budget Category Selections: ', category, subcategory);
    };

    const initializeData = (data: Voucher) => {
        let newData: Voucher = { ...data };

        return newData;
    };

    const handleDownload = () => {
        writeCheck();
    };

    const handleSelectedPerson = async (person: ChargeIndividual) => {
        person.voucherAccountId = voucherAccounts[selectedVoucherAccountIndex].id;
        await addChargeIndividual(person);
/*         let chargeIndividualsList = chargeIndividuals.slice();

        let chargeIndividual: ChargeIndividual = {
            id: person.id,
            personType: person.personType,
            clientCity: null,
            clientState: null,
            clientNumber: null,
            clientName: null,
            lmNo: person.id,
            firstName: person.firstName,
            lastName: person.lastName,
            creditCardDetailId: null,
            voucherAccountId: null
        };

        chargeIndividualsList?.push(chargeIndividual);

        setChargeIndividuals(chargeIndividualsList); */
    };

    const handleSelectedVouchers = (person: Personnel) => {
        console.log();
    };

/*     const handleVoid = (date: Date, voidBy: string, reason: string) => {
        let temp = voucherMaintenanceForm;

        temp.dateVoucherVoided = date;
        temp.isVoucherVoid = true;

        if (voidType === 'Voucher') {
            setValue('voucherMaintenanceForm.isVoucherVoid', true);
            setValue('voucherMaintenanceForm.dateVoucherVoided', moment(date).format('YYYY-MM-DD') as unknown as Date);
        } else {
            setValue('voucherMaintenanceForm.isCheckVoid', true);
            setValue('voucherMaintenanceForm.dateCheckVoided', moment(date).format('YYYY-MM-DD') as unknown as Date);
        }

        console.log(temp);
    }; */

    const GetIrsCategoryTypeIdFromString = (irsCategoryTypeString: string) => {
        switch (irsCategoryTypeString) {
            case 'Gross Proceeds Paid to Attorney':
            return '1';
        default:
            return '2';
        }
    };

    const addVendor = async (payload: Vendor) => {
        payload.taxType = GetIrsCategoryTypeIdFromString(payload.taxType);
        payload.vendorNumber = 0;
        payload.isActive = Number(payload.isActive);
        let result = await post(`/v1.0/AccountsPayable/vendors/create`, payload);

        if (response.ok) {
            getVendors(payload.vendorName);
        } else {
            console.log('Unable to add vendor!' + result);
        }

    };

    const handleConfirmRemovePerson = () => {
        removeSelectedPerson(selectedIndividualIndex);
    };

    const handleConfirmVoidVoucher = () => {
        voidVoucher();
        setVoidingVoucher(false);
    };

    const handleConfirmCreateCheck = () => {
        // writeCheck();
    };

    const displayWarning = (index: number) => {
        setSelectedIndividualIndex(index);
        showDialog(DialogList.WARNING);
    };

    const displayVoidVoucherDialog = () => {
        showDialog(DialogList.VOID_VOUCHER);
    };

/*     const displayVoidWarning = () => {
        setVoidingVoucher(true);
        showDialog(DialogList.WARNING);
    }; */

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const chooseVouchers = () => {
        showDialog(DialogList.CHOOSE_VOUCHERS_TO_PAY);
    };

    const writeCheck = () => {
        const voucherNumber = Number(vouchers?.items[voucherIndex].voucherNumber);
        getVoucherCheck(voucherNumber);
    };

    const handleWriteCheck = () => {
        // const voucherNumber = Number(vouchers?.items[voucherIndex].voucherNumber);
        // getVoucherCheck(voucherNumber);
        showDialog(DialogList.ENTER_CHECK_NUMBER);
    };

    const voidVoucher = () => {
        setVoidType('Voucher');
        let voucherToVoid = vouchers.items[voucherIndex];
        voucherToVoid.isVoucherVoid = true;
        voucherToVoid.dateVoucherVoided = new Date();
        updateVoucher(voucherToVoid);
    };

    const voidCheck = () => {
        setVoidType('Check');
        showDialog(DialogList.VOID_VOUCHER);
        console.log('');
    };

    const removeSelectedPerson = async (index: number) => {
        let selectedChargeIndividual = chargeIndividuals[index];
        await removeChargeIndividual(selectedChargeIndividual);
/*         let temp = chargeIndividuals.slice();

        if (temp.length > 0 && index >= 0) {
            temp.splice(index, 1);
            setChargeIndividuals(temp);
        }

        setSelectedIndividualIndex(-1); */
    };

    const onSubmit = async (data: Voucher) => {
        if (!!data) {
            let finalData = finalizeData(data);
            console.log(finalData);
        }
    };

    const getVendors = async (filter: string) => {
        if (!!filter && filter.length > 0) {
            if (isNaN(Number(filter))) {
                vendorSearchOptions?.addFilter(new ODataFilter('vd.NAME1', ODataFilterOperators.Contains, filter));
            } else {
                vendorSearchOptions?.addFilter(new ODataFilter('vd.VNDR_NO', ODataFilterOperators.Equals, filter));
                vendorSearchOptions?.addFilter(new ODataFilter('vd.NAME1', ODataFilterOperators.Contains, filter));
            }
        }
        
        const queryString = vendorSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/vendors${queryString}`);

        if (response.ok) {
            if (vendorSearchOptions.getPageNumber() > 1) {
                let tempResult = _.cloneDeep(vendors);
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setVendors(tempResult);
            } else {
                setVendors(result);
            }
            setFetchNextPage(result.pageNumber * result.pageSize < result.totalRecords);
        } else {
            console.log('Unable to get vendor data!!!');
        }
        vendorSearchOptions.clearFilters();
    };

    const finalizeData = (data: Voucher) => {
        // Get all the form values, then add in the Personnel model values that the form doesn't have
        let finalData: Voucher = {
            ...data,
        };

        return finalData;
    };

    // const getPersonnelBilling = async () => {
    //     let data = await get(`v1.0/landmen/${2}/get-personnel-billing`);

    //     if (response.ok) {
    //         // setVoucherExpenses(data);
    //     } else {
    //         window.alert('Unable to Retrieve Selected Personnel\'s Billing Information.');
    //     }
    // };

    // const updatePersonnelBilling = async (data: BillingInfo[]) => {
    //     if (!!data) {
    //         await put(`v1.0/landmen/${2}/save-personnel-billing`, data);

    //         if (response.ok) {
    //             window.alert('Update Successful');
    //             getPersonnelBilling();
    //         } else {
    //             window.alert(`Unable to Update Selected Personnel\'s Billing Information.`);
    //         }
    //     }
    // };
    const closeVoucher = () => {
        let voucherToClose = vouchers.items[voucherIndex];
        voucherToClose.closeDate = new Date();
        updateVoucher(voucherToClose);
    };

    const updateVoucher = async (voucher: Voucher) => {
        let result = await put(`/v1.0/AccountsPayable/voucher`, voucher);

        if (response.ok) {
            getVendors('');
        } else {
            console.log('Unable to update voucher!' + result);
        }
    };

    const addVoucher = async (voucher: Voucher) => {
        let result = await post(`/v1.0/AccountsPayable/voucher/create`, voucher);

        if (response.ok) {
            if (!isNaN(Number(result))) {
                let newSearchOptions = _.cloneDeep(voucherSearchOptions);
                newSearchOptions.addFilter(new ODataFilter('VCH_NO', ODataFilterOperators.Equals, result));
                setVoucherSearchOptions(newSearchOptions);
            } else {
                getVouchers();
            }
            setVoucherAccounts([]);
        } else {
            console.log('Unable to update voucher!' + result);
        }
    };

    const getVouchers = async () => {
        let result = await get(`/v1.0/AccountsPayable/vouchers${voucherSearchOptions?.toString()}`);

        if (response.ok) {
            if (voucherSearchOptions.getPageNumber() > 1) {
                let tempResult = _.cloneDeep(vouchers);
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setVouchers(tempResult);
            } else {
                setVouchers(result);
            }
            setFetchNextVouchersPage(result.pageNumber * result.pageSize < result.totalRecords);
        } else {
            console.log('Unable to get voucher data!!!');
        }
    };

    const getVoucherInvoices = async (voucherNumber: string) => {
        let result = await get(`/v1.0/AccountsPayable/voucher/voucherNumber/${voucherNumber}/invoices`);

        if (response.ok) {
            setVoucherInvoices(result);
        } else {
            console.log('Unable to get voucher Data!');
        }
    };

    const getBlankExpenseRows = (numberOfRows: number) => {
        let blankExpenseRows = [];
        let blankExpenseRowAaccountId = Constants.accountsPayableVoucherAccountsBlankAccountsBase;
        for (let blankRows = 0; blankRows < numberOfRows; blankRows++) {
            let blankExpenseRow = new Expense();
            blankExpenseRow.billingAccount = '1';
            blankExpenseRow.clientNumber = 90;
            blankExpenseRow.projectNumber = 1;
            blankExpenseRow.accountId = blankExpenseRowAaccountId++;
            blankExpenseRows.push(blankExpenseRow);
        }

        return blankExpenseRows;
    };

    const getVoucherAccounts = async (voucherNumber: string) => {
        // setVoucherAccounts([]);
        let result = await get(`/v1.0/AccountsPayable/voucheraccounts/voucherNumber/${voucherNumber}`);

        let newVoucherAccounts: Expense[] = [];
        if (response.ok && result?.items?.length > 0) {
            newVoucherAccounts = [...newVoucherAccounts].concat([...result?.items]);
        } else {
            console.log('Unable to get voucher accounts Data!');
        }
        let baseVoucherAccounts: Expense[] = [];
        baseVoucherAccounts = [...getBlankExpenseRows(3)];
        setVoucherAccounts(newVoucherAccounts.concat([...baseVoucherAccounts]));
    };

    const getVoucherReceipts = async (voucherNumber: string) => {
        let result = await get(`/v1.0/AccountsPayable/receipts/vouchers/${voucherNumber}`);

        if (response.ok) {
            setVoucherReceipts(result);
        } else {
            console.log('Unable to get voucher accounts Data!');
        }
    };

    const addVendorInvoice = async (payload: VendorInvoice) => {
        const existingInvoiceNumber = voucherInvoices?.find((vi: VendorInvoice) =>
            payload?.number === vi?.number
        );
        let result = undefined;
        if (!existingInvoiceNumber) {
            result = await post(`/v1.0/AccountsPayable/vendors/invoice/create`, payload);
        } else {
            alert('There is already an invoice with ' + payload?.number);
        }

        if (response.ok) {
            getVoucherInvoices(vouchers?.items[voucherIndex].voucherNumber);
        } else {
            console.log('Unable to add voucher invoice!' + result);
        }
    };

    const addChargeIndividual = async (payload: ChargeIndividual) => {
        let result = await post(`/v1.0/AccountsPayable/chargeindividual/create`, payload);

        if (response.ok) {
            const voucherTransactionId = voucherAccounts[selectedVoucherAccountIndex].id;
            getChargeIndividualsForVoucherAccount(voucherTransactionId);
        } else {
            console.log('Unable to add charge individual!' + result);
        }
    };

    const removeChargeIndividual = async (payload: ChargeIndividual) => {
        payload.voucherAccountId = voucherAccounts[selectedVoucherAccountIndex].id;
        let result = await del(`/v1.0/AccountsPayable/chargeindividual?voucherAccountId=${payload.voucherAccountId}&ccTransactionId=${payload.creditCardDetailId}&personType=${payload.personType}&clientNumber=${payload.clientNumber}&lmNumber=${payload.lmNo}`);

        if (response.ok) {
            getChargeIndividuals(vouchers.items[voucherIndex].voucherNumber);
        } else {
            console.log('Unable to delete charge individual!' + result);
        }
    };

    const removeVoucherAccount = (voucherAcccountIndex: number) => {
        if (!newVoucher && !!voucherAccounts && !!voucherAccounts[voucherAcccountIndex] && voucherAccounts[voucherAcccountIndex]?.id < Constants.accountsPayableVoucherAccountsBlankAccountsBase) {
            removeSavedVoucherAccount(voucherAccounts[voucherAcccountIndex]?.id);
        } else {
            let newVoucherAccounts = [...voucherAccounts];
            newVoucherAccounts.splice(voucherAcccountIndex, 1);
            setVoucherAccounts(newVoucherAccounts);
            // reset(newVoucherAccounts);
        }
    };

    const removeVendorInvoice = async (invoiceId: number) => {
        let result = await del(`/v1.0/AccountsPayable/vendor/invoice/${invoiceId}`);

        if (response.ok) {
            getVoucherInvoices(vouchers.items[voucherIndex].voucherNumber);
        } else {
            console.log('Unable to delete invoice!' + result);
        }
    };

    const removeSavedVoucherAccount = async (voucherAccountId: number) => {
        let result = await del(`/v1.0/AccountsPayable/voucheraccount/${voucherAccountId}`);

        if (response.ok) {
            getVoucherAccounts(vouchers.items[voucherIndex].voucherNumber);
        } else {
            console.log('Unable to delete invoice!' + result);
        }
    };

    const getChargeIndividuals = async (voucherNumber: string) => {
        let result = await get(`/v1.0/AccountsPayable/chargeindividuals/voucherNumber/${voucherNumber}`);

        if (response.ok) {
            setChargeIndividuals(result?.items);
        } else {
            console.log('Unable to get voucher accounts Data!');
        }
    };

    const getChargeIndividualsForVoucherAccount = async (voucherAccountId: number) => {
        let result = await get(`/v1.0/AccountsPayable/chargeindividuals/voucherAccount/${voucherAccountId}`);

        if (response.ok) {
            setChargeIndividuals([]);
            setChargeIndividuals(result);
        } else {
            console.log('Unable to get voucher accounts Data!');
        }
    };

    const getAllChargeIndividuals = async () => {
        let options: ODataOptions = new ODataOptions();
        options.addPaging(1, 100);
        let result = await get(`/v1.0/AccountsPayable/chargeindividuals${options.toString()}`);

        if (response.ok) {
            setAllChargeIndividuals(result?.items);
        } else {
            console.log('Unable to get all charge individual Data!');
        }
    };

    const getAccountInfo = async (voucherNumber: string, glAccountNumber: string) => {
        let result = await get(`/v1.0/AccountsPayable/accountinfo/voucherNumber/${voucherNumber}/glAccountNumber/${glAccountNumber}`);

        if (response.ok) {
            setAccountInfo(result);
        } else {
            console.log('Unable to get voucher Data!');
        }
    };

    // TODO: Finish billing code validation
    /*
    const getClient = async (clientNumber: number, index: number) => {
        let options = new ODataOptions();
        options.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, clientNumber));
        let result = await get(`/v1.0/AccountsPayable/client${options.toString()}`);

        let newClientVerifications = _.cloneDeep(clientValidations);
        if (response.ok) {
            if (!!result.clientNumber) {
                newClientVerifications.splice(index, 1, !!result.clientNumber ? true : false);
            }
        } else {
            newClientVerifications.splice(index, 1, false);
        }
        setClientValidations(newClientVerifications);
    };

     const getClients = async () => {
        let result = await get(`/v1.0/AccountsPayable/clients`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const handleApiError = (value: Response) => {
        console.log('api call failed: ' + value);
    };

    const handleApiCall = (value: Response) => {
        return new Promise<object>((resolve) => {
            if (value.ok) {
                value
                    .json()
                    .then((body) => resolve(body))
                    .catch(() => resolve(null));
            } else {
                resolve(value.json().then((errorResponse: ErrorResponse) => new ErrorResponse(errorResponse.messageCode, errorResponse.message)));
            }
        });
    };

    const getJwtToken = (): string => {
        return timeAndExpenseToken;
    };

    const createHeader = (type: string) => {
        let headers = {};

        // let jwtToken = getJwtToken();
        // jwt = undefined;

        const username = `Joe Example`;
        const password = `DudleyRocks025!`;
        if (type === 'jwt') {
            headers = {
                'un': `${username}`,
                'pw': `${password}`,
                // 'Connection': 'keep-alive',
                // 'content-type': 'application/json',
                // Authorization: `Bearer ${jwt}`,
            };
        } else if (type === 'validateProspect') {
            headers =  {
                'Tsjwt': timeAndExpenseToken,
                'content-type': 'application/json'
              };
        } else {
            headers = {
                'un': `${username}`,
                'pw': `${password}`,
                'content-type': 'application/json' };
        }

        return headers;
    };

    const getHeader = (jwt: string | undefined) => {
        const header: RequestInit = {
            headers: createHeader(jwt),
            method: 'GET',
            mode: 'cors',
        };
        return header;
    };

    const postHeader = (body: object, jwt: string | undefined = undefined) => {
        const header: RequestInit = {
            body: JSON.stringify(body),
            headers: createHeader('validateProspect'),
            method: 'POST',
            mode: 'cors',
        };
        return header;
    };

    const getRequest = async (url: string, jwt: string | undefined = undefined) => {
        return fetch(url, getHeader(jwt)).then(handleApiCall).catch(handleApiError);
    };

    const postRequest = async (url: string, body: object, jwt: string | undefined = undefined) => {
        return fetch(url, postHeader(body, jwt)).then(handleApiCall).catch(handleApiError);
    };

    const baseCalmsServicesUrl = `https://services.calms.net`;
    const baseTandEUrl = `https://time.calms.net`;

    // https://services.calms.net/api/tokenissue

    const getTEUserToken = async () => {
        const result = await getRequest(`${baseCalmsServicesUrl}/api/tokenissue`, 'jwt');
        setTimeAndExpenseToken((result as {timeAndExpenseJwt: string}).timeAndExpenseJwt);
    }; */

    // TODO: Finish billing code validation
/*     const validateBillingCode = async (index: number) => {
        const formValues = getValues();
        console.log(index + ' ' + formValues);
        const payload = {
            'clientNumber': `${formValues.voucherExpenses[index].clientNumber}`,
            'prospectNumber': `${formValues.voucherExpenses[index].projectNumber}`,
            'sectionNumber': 0,
            'unitNumber': 0};
        let data = await postRequest(`${baseTandEUrl}/api/entry/validateProspect`, payload as object, 'validateProspect');
        if (response.ok && (!(data as {error: string})?.error || (data as {error: string})?.error?.length === 0)) {
            console.log('========> Received response from T&E Service', data);
        } else {
            let newClientVerifications = _.cloneDeep(clientValidations);
            newClientVerifications.splice(index, 1, false);
            // let newClientValidations = [];
            // newClientValidations.push({index: index, error: true});
            setClientValidations(newClientVerifications);
            const errorText = (data as {error: string})?.error;
            console.log('Unable to validate billing code.' + errorText);
            const errorTextElement = document.getElementById('BillingCodeError');
            errorTextElement.innerText = errorText;
            errorTextElement.setAttribute('style', 'display: block; color: red');
        }
    }; */

    const getPersonnelEmployeePay = async () => {
        let data = await get(`v1.0/landmen/${2}/get-personnel-employeePay`);
        if (response.ok) {
            console.log('========> Received Employee Pay Info', data);
            setSelectedEmployeePay(data);
        } else {
            console.log('Unable to Retrieve Selected Personnel\'s Billing Information.');
            // window.alert('Unable to Retrieve Selected Personnel\'s Billing Information.');
        }
    };

    const incrementVendors = () => {
        if (!!fetchNextPage) {
            // setFetchNextPage(vendors.pageNumber * vendors.pageSize < vendors.totalRecords);
            let newSearchOptions = _.cloneDeep(vendorSearchOptions);
            newSearchOptions.incrementPageNumber();
            setVendorSearchOptions(newSearchOptions);
        }
    };

    const incrementVouchers = () => {
        if (!!fetchNextVouchersPage) {
            let newSearchOptions = _.cloneDeep(voucherSearchOptions);
            newSearchOptions.incrementPageNumber();
            setVoucherSearchOptions(newSearchOptions);
        }
    };

    const findVendor = (newVoucherClicked: boolean) => {
        setNewVoucher(newVoucherClicked);
        dispatch(actions.layout.showDialog(DialogList.FIND_VENDOR));
    };

    const findAvailableAccounts = () => {
        dispatch(actions.layout.showDialog(DialogList.FIND_AVAILABLE_ACCOUNTS));
    };

    const addVendorInvoices = () => {
        if (!!vouchers?.items[voucherIndex]?.vendorNumber) {
            if (!newVoucher) {
                setAddingJustInvoices(true);
            } else {
                dispatch(actions.layout.showDialog(DialogList.ADD_VENDOR_INVOICES));
            }
        }
    };

/*     const getTempAccountId = () => {
        let tempVoucherList = _.cloneDeep(voucherAccounts);
        let largestId = 0;
        tempVoucherList.forEach((va: Expense) => {
            largestId = va.id > largestId ? va.id : largestId;
        });
        return -(largestId + 1) !== -1 ? -(largestId + 1) : -100;
    }; */

    const resetVendorSearchOptions = () => {
        vendors.items = [];
        setVendors(vendors);
        setFetchNextPage(true);
        let newVendorSearchOptions = _.cloneDeep(vendorSearchOptions);
        newVendorSearchOptions.clearFilters();
        newVendorSearchOptions.addPaging(1, 50);
        // newVendorSearchOptions.addSkipTop(0, 50);
        setVendorSearchOptions(newVendorSearchOptions);
    };

/*     const resetVoucherSearchOptions = () => {
        vouchers.items = [];
        setVouchers(vouchers);
        setFetchNextPage(true);
        let newVoucherSearchOptions = _.cloneDeep(voucherSearchOptions);
        newVoucherSearchOptions.clearFilters();
        newVoucherSearchOptions.addPaging(1, 50);
        setVoucherSearchOptions(newVoucherSearchOptions);
    }; */

    const addLocalVoucherAccount = () => {
        let savedVoucherAccounts = voucherAccounts.filter(va =>
            va.accountId < Constants.accountsPayableVoucherAccountsUnsavedAccountsBase
            );
        let currentVoucherAccounts = [...savedVoucherAccounts].concat(uncommittedVoucherAccounts);
        setVoucherAccounts(currentVoucherAccounts);
    };

    const addUncommittedVoucherAccount = (ledgerAccount: LedgerAccount) => {
        let tempVoucherList = (!!uncommittedVoucherAccounts && uncommittedVoucherAccounts?.length > 0) ? _.cloneDeep(uncommittedVoucherAccounts) : [];

        let existingUnsavedVoucherAccounts = tempVoucherList.filter(ue =>
            ue.accountId >= Constants.accountsPayableVoucherAccountsUnsavedAccountsBase
        );
        let currentMaxAccountId = Constants.accountsPayableVoucherAccountsUnsavedAccountsBase;
        if (!!existingUnsavedVoucherAccounts && existingUnsavedVoucherAccounts.length > 0) {
            currentMaxAccountId = Math.max(...existingUnsavedVoucherAccounts?.map(va => va.accountId)) + 1;
        }
        let uncommittedVoucherAccount = new Expense();
        uncommittedVoucherAccount.accountId = currentMaxAccountId;
        uncommittedVoucherAccount.accountNumber = ledgerAccount.accountNumber;
        uncommittedVoucherAccount.accountDescriptor = ledgerAccount.description;
        uncommittedVoucherAccount.description = 'Description required';
        uncommittedVoucherAccount.billingAccount = billingAccounts[0]?.description;
        uncommittedVoucherAccount.clientNumber = 90;
        uncommittedVoucherAccount.projectNumber = 1;
        // let newUncommittedVoucherAccounts = [];
        existingUnsavedVoucherAccounts.push(uncommittedVoucherAccount);
        setUncommittedVoucherAccounts(existingUnsavedVoucherAccounts);
    };
/*
    const addLocalVoucherAccount = () => {

    }
     const addLocalVoucherAccount = (ledgerAccount: LedgerAccount) => {
        let tempVoucherList = (!!uncommittedVoucherAccounts && uncommittedVoucherAccounts?.length > 0) ? _.cloneDeep(uncommittedVoucherAccounts) : [];
        let unsavedVoucherAccount = new Expense();
        unsavedVoucherAccount.accountDescriptor = ledgerAccount?.description;
        unsavedVoucherAccount.accountNumber = ledgerAccount?.accountNumber;
        unsavedVoucherAccount.clientNumber = accountInfo?.clientNumber;
        unsavedVoucherAccount.projectNumber = accountInfo?.projectNumber;
        unsavedVoucherAccount.sectionNumber = accountInfo?.sectionNumber;
        unsavedVoucherAccount.unitNumber = accountInfo?.unitNumber;
        unsavedVoucherAccount.description = 'Enter a description.';
        unsavedVoucherAccount.accountId = 0;
        let existingUnsavedVoucherAccounts = tempVoucherList.filter(ue =>
            ue.accountId !== -1
        );
        existingUnsavedVoucherAccounts.push(unsavedVoucherAccount);
        let finalUnsaveVoucherList = [...existingUnsavedVoucherAccounts].concat(getBlankExpenseRows(3));
        setVoucherAccounts(finalUnsaveVoucherList);
        // setTriggerHideDialog(new Object());
    };

    const prepareLocalVoucherAccounts = (ledgerAccount: LedgerAccount) => {
        let uncommittedVoucherAccount = new Expense();
        uncommittedVoucherAccount.accountNumber = ledgerAccount.accountNumber;
        uncommittedVoucherAccount.accountDescriptor = ledgerAccount.description;
        uncommittedVoucherAccount.description = 'Description required';
        uncommittedVoucherAccount.billingAccount = billingAccounts[0].description;
        uncommittedVoucherAccount.clientNumber = 90;
        uncommittedVoucherAccount.projectNumber = 1;
        let newUncommittedVoucherAccounts = [];
        newUncommittedVoucherAccounts.push(uncommittedVoucherAccount);
        setUncommittedVoucherAccounts(newUncommittedVoucherAccounts);
    }; */
/*
    const prepareLocalVoucherAccounts = (ledgerAccount: LedgerAccount) => {
        //setUncommittedVoucherAccounts(voucherAccounts);
        // setVoucherAccounts([]);
        setSelectedLedgerAccount(ledgerAccount);
        hideDialog();
    }; */

/*     const addLocalVoucherAccount  = (ledgerAccount: LedgerAccount) => {
        let unsavedVoucherAccount = new Expense();
        unsavedVoucherAccount.accountDescriptor = ledgerAccount?.description;
        unsavedVoucherAccount.accountNumber = ledgerAccount?.accountNumber;
        unsavedVoucherAccount.clientNumber = accountInfo?.clientNumber;
        unsavedVoucherAccount.projectNumber = accountInfo?.projectNumber;
        unsavedVoucherAccount.sectionNumber = accountInfo?.sectionNumber;
        unsavedVoucherAccount.unitNumber = accountInfo?.unitNumber;
        unsavedVoucherAccount.description = 'Enter a description.';
        unsavedVoucherAccount.accountId = 0;
        let finalUnsaveVoucherList: Expense[] = [];
        finalUnsaveVoucherList.push(unsavedVoucherAccount);
        setVoucherAccounts(finalUnsaveVoucherList);
        setTriggerHideDialog(new Object());
    }; */

    const getUnsavedVoucherAccounts = () => {
        let unSavedVoucherAccounts = getValues()?.voucherAccounts as Array<Expense>;
        for (let accountIndex = 0; accountIndex < voucherAccounts?.length; accountIndex++) {
            if (voucherAccounts[accountIndex].accountId >= Constants.accountsPayableVoucherAccountsUnsavedAccountsBase) {
                unSavedVoucherAccounts[accountIndex].accountId = voucherAccounts[accountIndex].accountId;
                unSavedVoucherAccounts[accountIndex].amount = Number(unSavedVoucherAccounts[accountIndex].amount);
                unSavedVoucherAccounts[accountIndex].clientNumber = Number(unSavedVoucherAccounts[accountIndex].clientNumber);
                unSavedVoucherAccounts[accountIndex].projectNumber = Number(unSavedVoucherAccounts[accountIndex].projectNumber);
                // tslint:disable-next-line
                unSavedVoucherAccounts[accountIndex].sectionNumber = !isNaN(Number(unSavedVoucherAccounts[accountIndex].sectionNumber)) ?  Number(unSavedVoucherAccounts[accountIndex].sectionNumber) : null;
                // tslint:disable-next-line
                unSavedVoucherAccounts[accountIndex].unitNumber = !isNaN(Number(unSavedVoucherAccounts[accountIndex].unitNumber)) ?  Number(unSavedVoucherAccounts[accountIndex].unitNumber) : null;
            }
        }
        // const unSavedVoucherAccounts = getValues()?.voucherAccounts as Array<Expense>;
        const voucherAccountsToSave = unSavedVoucherAccounts.filter((va: Expense) =>
            va.accountId >= Constants.accountsPayableVoucherAccountsUnsavedAccountsBase
            );
        return voucherAccountsToSave;
    };
    /* const getUnsavedVoucherAccounts = () => {
        let voucherAccountsToSave = new Array<Expense>();
        const unsavedVoucherAccounts = getValues()?.voucherAccounts;
        const unsavedExpenses = getValues()?.voucherExpenses;
        const newVoucherAccounts = voucherAccounts.filter((va) =>
            va.accountId !== undefined && va.accountId >= Constants.accountsPayableVoucherAccountsUnsavedAccountsBase
        );
        if (!!newVoucherAccounts) {
            newVoucherAccounts.forEach((va) => {
                const newVoucherAccountIndex = unsavedExpenses?.findIndex((va2: Expense) =>
                    va2.accountNumber === va.accountNumber &&
                    va.accountId < 1
                );
                console.log(newVoucherAccountIndex);
                if (newVoucherAccountIndex > -1) {
                    let newVoucherAccount = new Expense();
                    newVoucherAccount.voucherNumber = !!newVoucher ? 0 : (!isNaN(Number(vouchers?.items[voucherIndex]?.voucherNumber)) ?
                        Number(vouchers.items[voucherIndex].voucherNumber) : undefined);
                    newVoucherAccount.voucherId = 0;
                    newVoucherAccount.accountDescriptor = va.accountDescriptor;
                    newVoucherAccount.description = unsavedVoucherAccounts[newVoucherAccountIndex].description;
                    newVoucherAccount.billingAccount = unsavedVoucherAccounts[newVoucherAccountIndex].billingAccount;
                    newVoucherAccount.expenseType = unsavedExpenses[newVoucherAccountIndex].expenseType;
                    newVoucherAccount.amount = !isNaN(parseFloat(unsavedVoucherAccounts[newVoucherAccountIndex].amount)) ?
                        parseFloat(unsavedVoucherAccounts[newVoucherAccountIndex].amount) : 0;
                    newVoucherAccount.accountNumber = unsavedExpenses[newVoucherAccountIndex].accountNumber;
                    newVoucherAccount.clientNumber = !isNaN(Number(unsavedExpenses[newVoucherAccountIndex].clientNumber)) ?
                        Number(unsavedExpenses[newVoucherAccountIndex].clientNumber) : undefined;
                    newVoucherAccount.projectNumber = !isNaN(Number(unsavedExpenses[newVoucherAccountIndex].projectNumber)) ?
                        Number(unsavedExpenses[newVoucherAccountIndex].projectNumber) : undefined;
                    newVoucherAccount.sectionNumber = !isNaN(Number(unsavedExpenses[newVoucherAccountIndex].sectionNumber)) ?
                        Number(unsavedExpenses[newVoucherAccountIndex].sectionNumber) : undefined;
                    newVoucherAccount.unitNumber = !isNaN(Number(unsavedExpenses[newVoucherAccountIndex].unitNumber)) ?
                        Number(unsavedExpenses[newVoucherAccountIndex].unitNumber) : undefined;
                    voucherAccountsToSave.push(newVoucherAccount);
                    // addVoucherAccount(newVoucherAccount);
                }
            });
        }
        return voucherAccountsToSave;
    }; */

    const getUnsavedInvoices = () => {
        let invoicesToSave = [...voucherInvoices];
        invoicesToSave.forEach((vi) => {vi.voucherNumber = '0'; vi.vendorNumber = Number(vi.vendorNumber); });
        return invoicesToSave;
    };

    // TODO: finish billing code validation 
/*     const validateClients = async () => {
        // Verify billing codes for all voucher accounts
        const formData = getValues();
        const voucherExpenses = formData?.voucherExpenses;
        for (let expenseIndex = 0; expenseIndex < formData?.voucherExpenses?.length; expenseIndex++) {
            if (!!voucherExpenses[expenseIndex]?.clientNumber) {
                await getClient(voucherExpenses[expenseIndex]?.clientNumber, expenseIndex);
            }
        }
    }; */

    const onSaveChanges = async () => {
        // save unsaved voucher accounts
        if (!!isDirty || (!!uncommittedVoucherAccounts && uncommittedVoucherAccounts?.length > 0)) {
            // const unsavedVoucherAccounts = getValues()?.voucherAccounts;
            // const unsavedExpenses = getValues()?.voucherExpenses;
            const editedFields = dirtyFields;
            // for (let voucherAccountIndex = 0; voucherAccountIndex < voucherAccounts.length; voucherAccountIndex++) {
             //   if (!!voucherAccounts[voucherAccountIndex]) {
                    // let newVoucherAccount = voucherAccounts[voucherAccountIndex];
            let editedValues =  (editedFields?.currentVoucherMaintenanceForm as VoucherMaintenanceForm);
            editedValues = (editedValues === undefined ? editedFields?.voucherMaintenanceForm as VoucherMaintenanceForm : editedValues);
            if (!!editedValues || (!!uncommittedVoucherAccounts && uncommittedVoucherAccounts?.length > 0)) {
                let editedVoucher = (getValues()?.currentVoucherMaintenanceForm as VoucherMaintenanceForm);
                editedVoucher.voucherAmount = Number(editedVoucher.voucherAmount);
                editedVoucher.invoiceDate = new Date();
                editedVoucher.invoiceAmount = Number(editedVoucher.invoiceAmount);
                editedVoucher.checkNumber = Number(editedVoucher.checkNumber);
                editedVoucher.voucherNumber = editedVoucher?.voucherNumber?.toString();
                const currentVoucherId = !!newVoucher ? 0 : getValues('currentVoucherMaintenanceForm.voucherNumber');
                if (!currentVoucherId) {
                    editedVoucher.dueDate = null;
                    editedVoucher.closeDate = null;
                    editedVoucher.dateVoucherVoided = null;
                    editedVoucher.dateCheckVoided = null;
                    editedVoucher.checkDate = null;
                    editedVoucher.vendorNumber =  editedVoucher.vendorId;
                    editedVoucher.vendorInvoice = getValues('currentVoucherMaintenanceForm.vendorInvoice');
                    editedVoucher.voucherAccounts = getUnsavedVoucherAccounts();
                    editedVoucher.voucherInvoices = getUnsavedInvoices();
                    addVoucher(editedVoucher);
                } else {
                    editedVoucher.dateVoucherVoided = null;
                    editedVoucher.vendorInvoice = getValues('currentVoucherMaintenanceForm.vendorInvoice');
                    editedVoucher.voucherAccounts = getUnsavedVoucherAccounts();
                    editedVoucher.voucherInvoices = getUnsavedInvoices();
                    updateVoucher(editedVoucher);
                }
            }

/*             if (editedFields?.voucherAccounts?.length > 0 || editedFields?.voucherExpenses?.length > 0) {
                const newVoucherAccounts = voucherAccounts.filter((va) =>
                    va.accountId !== undefined && va.accountId !== -1
                );
                if (!!newVoucherAccounts) {
                    newVoucherAccounts.forEach((va) => {
                        const newVoucherAccountIndex = unsavedExpenses.findIndex((va2: Expense) => 
                            va2.accountNumber === va.accountNumber &&
                            va.accountId !== -1 &&
                            va.accountId < 0
                        );
                        console.log(newVoucherAccountIndex);
                        if (newVoucherAccountIndex > -1) {
                            let newVoucherAccount = new Expense();
                            newVoucherAccount.voucherNumber = !!newVoucher ? 0 : (!isNaN(Number(vouchers.items[voucherIndex].voucherNumber)) ?
                                Number(vouchers.items[voucherIndex].voucherNumber) : undefined);
                            newVoucherAccount.voucherId = 0;
                            newVoucherAccount.accountDescriptor = va.accountDescriptor;
                            newVoucherAccount.description = unsavedVoucherAccounts[newVoucherAccountIndex].description;
                            newVoucherAccount.billingAccount = unsavedVoucherAccounts[newVoucherAccountIndex].billingAccount;
                            newVoucherAccount.expenseType = unsavedExpenses[newVoucherAccountIndex].expenseType;
                            newVoucherAccount.amount = !isNaN(parseFloat(unsavedVoucherAccounts[newVoucherAccountIndex].amount)) ?
                                parseFloat(unsavedVoucherAccounts[newVoucherAccountIndex].amount) : 0;
                            newVoucherAccount.accountNumber = unsavedExpenses[newVoucherAccountIndex].accountNumber;
                            newVoucherAccount.clientNumber = !isNaN(Number(unsavedExpenses[newVoucherAccountIndex].clientNumber)) ?
                                Number(unsavedExpenses[newVoucherAccountIndex].clientNumber) : undefined;
                            newVoucherAccount.projectNumber = !isNaN(Number(unsavedExpenses[newVoucherAccountIndex].projectNumber)) ?
                                Number(unsavedExpenses[newVoucherAccountIndex].projectNumber) : undefined;
                            newVoucherAccount.sectionNumber = !isNaN(Number(unsavedExpenses[newVoucherAccountIndex].sectionNumber)) ?
                                Number(unsavedExpenses[newVoucherAccountIndex].sectionNumber) : undefined;
                            newVoucherAccount.unitNumber = !isNaN(Number(unsavedExpenses[newVoucherAccountIndex].unitNumber)) ?
                                Number(unsavedExpenses[newVoucherAccountIndex].unitNumber) : undefined;
                            addVoucherAccount(newVoucherAccount);
                        }
                    });
                }
            } */
               // }
           // }
        }

        setNewVoucher(false);
        // let newClientValidations: boolean[] = [];
        const errorTextElement = document.getElementById('BillingCodeError');
        if (!!errorTextElement) {
            errorTextElement.innerText = '';
            errorTextElement.setAttribute('style', 'display: none');
        }
        // newClientValidations.push({index: 0, error: false});
        // setClientValidations(newClientValidations);
    };

/*     const addVoucherAccount = async (ledgerAccount: Expense) => {
        console.log(ledgerAccount);
        let result = await post(`/v1.0/AccountsPayable/vouchers/account/create`, ledgerAccount);

        if (response.ok) {
            getVoucherAccounts(vouchers.items[voucherIndex].voucherNumber);
            getChargeIndividuals(vouchers.items[voucherIndex].voucherNumber);
        } else {
            console.log('Unable to add voucher account!' + result);
        }
    }; */

    const displayTitle = () => {
        const title = 'A/P Voucher Accounts';

        return title;
    };

    const getChargeIndividualsForSelectedVoucherTransaction = (voucherAccountIndex: number) => {
        if (!!voucherAccounts && voucherAccounts?.length > voucherAccountIndex) {
            setSelectedVoucherAccountIndex(voucherAccountIndex);
            console.log (selectedVoucherAccountIndex);
            const voucherTransactionId = voucherAccounts[voucherAccountIndex].id;
            const voucherNumber = vouchers?.items[voucherIndex]?.voucherNumber;
            getVoucherReceipts(voucherNumber);
            getChargeIndividualsForVoucherAccount(voucherTransactionId);
            getAccountInfo(voucherNumber, voucherAccounts[voucherAccountIndex].accountNumber);
            // getChargeIndividuals(vouchers?.items[voucherIndex]?.voucherNumber);
        }
    };

/*     const getRandomLongInt = (min: number, max: number) => {
        // Generate a random number between 0 and 1
        const random = Math.random();

        // Scale the random number to the desired range
        const scaled = random * (max - min + 1);

        // Round down to an integer
        const int = Math.floor(scaled);

        // Add the minimum value to shift the range
        return int + min;
    }; */

    const displayAccountInfo = () => {
            return (
                <div style={{marginLeft: '7rem'}}>
                    <RHFInputBox
                        label="Client"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`client`}
                        type="text"
                        defaultVal={accountInfo?.clientName}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="Project"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`project`}
                        type="text"
                        defaultVal={accountInfo?.projectName}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="Section"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`section`}
                        type="text"
                        defaultVal={accountInfo?.sectionName}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="Unit"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`unit`}
                        type="text"
                        defaultVal={accountInfo?.unitNumber ? accountInfo?.unitNumber + '' : ''}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="Billing Account"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`billingAccount`}
                        type="text"
                        defaultVal={accountInfo?.billingAccount + ''}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="G/L Account"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`glAccount`}
                        type="text"
                        defaultVal={accountInfo?.glAccount + ''}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                </div>
            );
    };

    const displayChargeIndividuals = () => {
        if (!!chargeIndividuals && chargeIndividuals?.length > 0) {
            return <div>
                <table>
                    <thead>
                        <tr>
                            <th style={{ width: '20%' }}>Type</th>
                            <th style={{ width: '12%' }}>Client No.</th>
                            <th style={{ width: '28%' }}>Client/Company Name</th>
                            <th style={{ width: '10%' }}>Id No.</th>
                            <th style={{ width: '25%' }}>Name</th>
                            <th style={{ width: '5%' }}/>
                        </tr>
                    </thead>
                {chargeIndividuals?.map((x: ChargeIndividual, index: number) => {
                    return (
                        <tbody key={x.id}>
                            <tr className="table-item-hover" style={{ textAlign: 'center' }}>
                                <td style={{ width: '20%' }}>
                                    <label>{x.personType}</label>
                                </td>
                                <td style={{ width: '12%' }}>
                                    <label>{x.clientNumber}</label>
                                </td>
                                <td style={{ width: '28%' }}>
                                    <label>{x.clientName}</label>
                                </td>
                                <td style={{ width: '10%' }}>
                                    <label>{x.lmNo + ''}</label>
                                </td>
                                <td style={{ width: '30%' }}>
                                    <label>{x.firstName + ' ' + x.lastName}</label>
                                </td>
                                <td style={{ width: '5%' }}>
                                    <Button 
                                        reactIcon={IoMdCloseCircleOutline} 
                                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                        iconHoverColor="red"
                                        title="Remove Charge Individual"
                                        style={{ height: '3rem', background: 'transparent' }} 
                                        onClick={() => displayWarning(index)}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>;
        } else {
            return <div className="bold-centered">No Charge Individuals</div>;
        }
    };

    const displayLegacyVoucherReceipts = () => {
        return <div>
            <table>
                <thead>
                    <tr>
                        <th>File Name</th>
                        <th>Description</th>
                        <th>File Date</th>
                        <th>File Type</th>
                        <th>File Size</th>
                    </tr>
                </thead>
                {voucherReceipts?.items?.map((x: VoucherReceipt, index: number) => {
                    return (
                        <tbody key={x.id}>
                            <tr className="table-item-hover" style={{ textAlign: 'center' }}>
                                <td style={{ width: '20%' }}>
                                    <RHFInputBox
                                        name={`voucherReceipts[${index}].fileType`}
                                        type="text"
                                        defaultVal={x.fileType}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`voucherReceipts[${index}].description`}
                                        type="text"
                                        defaultVal={x.description}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '30%' }}>
                                    <RHFInputBox
                                        name={`voucherReceipts[${index}].fileDate`}
                                        type="text"
                                        defaultVal={x.fileDate.toString()}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`voucherReceipts[${index}].fileType`}
                                        type="text"
                                        defaultVal={x.fileType}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '30%' }}>
                                    <RHFInputBox
                                        name={`voucherReceipts[${index}].fileSize`}
                                        type="text"
                                        defaultVal={x.fileSize.toString()}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>;
    };

    const displayVoucherAccounts = () => {
        return <div>
            <table>
                <thead>
                    <tr>
                        <th>{''}</th>
                        <th>Account No.</th>
                        <th>Account Descriptor</th>
                        <th>Amount</th>
                        <th>Description</th>
                        <th className="diagonal-header">Client </th>
                        <th className="diagonal-header">Project</th>
                        <th className="diagonal-header">Section</th>
                        <th className="diagonal-header">Unit</th>
                        <th>Billing Account</th>
                        <th>Expense Type</th>
                        <th>Budget Category Name</th>
                        <th>Budget Subcategory Name</th>
                    </tr>
                </thead>
                {voucherAccounts.length > 0 && voucherAccounts?.map(
                    (x: Expense, index: number) => {
                    console.log('Account Id: ' + x.accountId);
                    return (
                        <tbody key={x.accountId}>
                            <tr onClick={() => getChargeIndividualsForSelectedVoucherTransaction(index)} className="table-item-hover" style={{ textAlign: 'center' }}>
                                <td style={{ width: '2%' }}>
                                    <Button
                                        reactIcon={IoMdCloseCircleOutline}
                                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                        iconHoverColor="red"
                                        title="Remove Voucher Account"
                                        style={{ height: '3rem', background: 'transparent' }}
                                        onClick={() => removeVoucherAccount(index)}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`voucherAccounts[${index}].accountNumber`}
                                        type="text"
                                        defaultVal={x.accountNumber}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%', background: '#d5f7f5' }}
                                        bodyStyle={{ width: '100%' }}
                                        onDoubleClick={() => findAvailableAccounts()}
                                    />
                                </td>
                                <td style={{ width: '15%' }}>
                                    <RHFInputBox
                                        name={`voucherAccounts[${index}].accountDescriptor`}
                                        type="text"
                                        defaultVal={x.accountDescriptor}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        onChange={() => calculateTotal()}
                                        name={`voucherAccounts[${index}].amount`}
                                        type="number"
                                        defaultVal={x.amount + ''}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`voucherAccounts[${index}].description`}
                                        type="text"
                                        defaultVal={x.description}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{  width: '3%' }}>
                                    <RHFInputBox
                                        name={`voucherAccounts[${index}].clientNumber`}
                                        defaultVal={!!x.clientNumber ? x.clientNumber + '' : ''}
                                        style={{ width: '40px'}}
                                        // TODO: Finish billing code validation
                                        // style={(clientValidations?.length > 0 && !clientValidations[index]) ? { width: '40px', border: '2px solid red'} : { width: '40px'}}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        name={`voucherAccounts[${index}].projectNumber`}
                                        defaultVal={!!x.projectNumber ? x.projectNumber + '' : ''}
                                        style={{ width: '40px'}}
                                        register={register}
                                        errors={errors}
                                        // TODO: Finish billing code validation
                                        // onBlur={() => validateBillingCode(index)}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        name={`voucherAccounts[${index}].sectionNumber`}
                                        defaultVal={!!x.sectionNumber ? x.sectionNumber + '' : ''}
                                        style={{ width: '40px'}}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        name={`voucherAccounts[${index}].unitNumber`}
                                        defaultVal={!!x.unitNumber ? x.unitNumber + '' : ''}
                                        style={{ width: '40px'}}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFSelect
                                        name={`voucherAccounts[${index}].billingAccount`}
                                        defaultVal={!x.billingAccount ? 1 : x.billingAccount}
                                        options={billingAccounts?.map(ba => {
                                            return { value: ba.code, label: ba.description };
                                            })}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFSelect
                                        name={`voucherAccounts[${index}].expenseType`}
                                        defaultVal={x.expenseType}
                                        options={Object.values(ExpenseType).map(value => ({value: value, label: value}))}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`voucherAccounts[${index}].budgetCategoryName`}
                                        type="text"
                                        defaultVal={x.budgetCategoryName}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`voucherAccounts[${index}].budgetSubcategoryName`}
                                        type="text"
                                        defaultVal={x.budgetSubcategoryName}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '1%', padding: '0' }}>
                                    <Button 
                                        className="blue-hover-button"
                                        reactIcon={FaPlusCircle}
                                        iconStyle={{width: '1.5rem', height: '1.5rem', marginBottom: '.5rem'}}
                                        style={{ height: '3rem', background: 'transparent' }} 
                                        onClick={() => defineBudgetCategory(x, index)}
                                        title="Add Budget Category / Subcategory"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>;
    };
 
    const displayTotal = () => {
        return <div className="form-row" style={{marginLeft: '16.7%'}}>
            <RHFInputBox
                label="Total"
                labelOnLeft={true}
                name={`total`}
                type="text"
                // defaultVal={bill.classification}
                register={register}
                errors={errors}
                style={{ width: '100%', border: '2px solid black', textAlign: 'right' }}
                bodyStyle={{ width: '18rem' }}
            />
        </div>;
    };

    const buttonClick = () => {
        console.log('Button Clicked');
    };

    const GetMostRecentInvoiceDate = (invoices: VendorInvoice[]) => {
        const dateValues = invoices.map(element => {
            const dateValue = new Date(element.date).getTime();
            return dateValue;
          });
        return new Date(Math.max(...dateValues));
    };

    const clearVoucherAccounts = (invoices: VendorInvoice[]) => {
        // setVoucherAccounts([]);
        setNewInvoices(invoices);
    };

    const prepareVoucherForm = (invoices: VendorInvoice[]) => {
        const invoiceDate = GetMostRecentInvoiceDate(invoices);
        const vendorNumber = selectedVendorIndex === -1 ? vouchers?.items[voucherIndex + 1]?.vendorNumber : vendors.items[selectedVendorIndex]?.vendorNumber;
        const vendorName = selectedVendorIndex === -1 ? vouchers?.items[voucherIndex + 1]?.vendorName : vendors.items[selectedVendorIndex]?.vendorName;
        // const invoiceDate = selectedVendorIndex === -1 ? vouchers.items[voucherIndex].invoiceDate : new Date().toDateString();
        // setValue(`voucherMaintenanceForm.vendorInvoice`, invoice?.number);
        setValue(`currentVoucherMaintenanceForm.vendorId`, vendorNumber);
        setValue(`currentVoucherMaintenanceForm.vendorName`, vendorName);
        setValue(`currentVoucherMaintenanceForm.vendorNumber`, vendorNumber);
        // setValue(`currentVoucherMaintenanceForm.invoiceAmount`, invoice?.amount);
        setValue(`currentVoucherMaintenanceForm.voucherAmount`, 0);
        setValue(`currentVoucherMaintenanceForm.invoiceDate`, moment(invoiceDate).format('YYYY-MM-DD') as unknown as Date);
        setValue(`currentVoucherMaintenanceForm.description`, '');
        setValue(`currentVoucherMaintenanceForm.voucherId`, '');
        setValue(`currentVoucherMaintenanceForm.voucherNumber`, '');
        setValue(`currentVoucherMaintenanceForm.checkNumber`, '');
        setValue(`currentVoucherMaintenanceForm.checkDate`, new Date());
        setValue(`currentVoucherMaintenanceForm.dueDate`, new Date());
        setValue(`currentVoucherMaintenanceForm.closeDate`, new Date());
        setValue(`currentVoucherMaintenanceForm.dateVoucherVoided`, new Date());
        setValue(`currentVoucherMaintenanceForm.dateCheckVoided`, new Date());
        setSelectedVendorIndex(-1);
        let baseVoucherAccounts: Expense[] = [];
        baseVoucherAccounts = getBlankExpenseRows(3);
        setVoucherAccounts(baseVoucherAccounts);
        setChargeIndividuals([]);
        setAccountInfo(undefined);
        setVoucherReceipts(undefined);
        setValue(`currentVoucherMaintenanceForm.total`, 0);
    };

    const nextVoucher = () => {
        if ((voucherIndex + 1) < vouchers?.items?.length) {
            setVoucherAccounts([]);
            setChargeIndividuals([]);
            // getAccountInfo(vouchers?.items[voucherIndex + 1]?.voucherNumber);
            getVoucherAccounts(vouchers?.items[voucherIndex + 1]?.voucherNumber);
            getVoucherReceipts(vouchers?.items[voucherIndex + 1]?.voucherNumber);
            getChargeIndividuals(vouchers?.items[voucherIndex + 1]?.voucherNumber);
            getVoucherInvoices(vouchers?.items[voucherIndex + 1]?.voucherNumber);
            setVoucherIndex(voucherIndex + 1);
            if (voucherIndex + 2 > vouchers?.items?.length) {
                incrementVouchers();
            }
        } else {
            alert('No more record!');
        }
    };

    const previousVoucher = () => {
        if (voucherIndex > 0) {
            setVoucherAccounts([]);
            setChargeIndividuals([]);
            // getAccountInfo(vouchers?.items[voucherIndex - 1]?.voucherNumber);
            getVoucherAccounts(vouchers?.items[voucherIndex - 1]?.voucherNumber);
            getVoucherReceipts(vouchers?.items[voucherIndex - 1]?.voucherNumber);
            getChargeIndividuals(vouchers?.items[voucherIndex - 1]?.voucherNumber);
            getVoucherInvoices(vouchers?.items[voucherIndex - 1]?.voucherNumber);
            setVoucherIndex(voucherIndex > 0 ? voucherIndex - 1 : voucherIndex);
        }
    };

    const moveToLastVoucher = () => {
        setVoucherIndex(vouchers?.items?.length > 0 ? vouchers?.items?.length - 1 : 0);
    };

    const findPerson = () => {
        console.log('Add Person Button Clicked');
        showDialog(DialogList.FIND_PERSON);
    };

    return (
        <div>
            <APNavBar/>
            <form id="employeePayForm" onSubmit={handleSubmit(onSubmit)}>
                <Page className="dlc-maxer-width">
                    <Page.Section width={8}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={displayTitle()}>
                                <div style={{ padding: '.5rem' }}>
                                    <div className="form-row" style={{ marginBottom: '0' }}>
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Query Data"
                                            reactIcon={BsLightningFill}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => buttonClick}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Void an AP Voucher"
                                            reactIcon={MdDoNotDisturb}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => displayVoidVoucherDialog()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Reports"
                                            reactIcon={VscGraph}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                            onClick={() => reportOptions()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Add New Voucher"
                                            reactIcon={BiReceipt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                            onClick={() => findVendor(true)}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Close Voucher"
                                            reactIcon={FaLock}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '1.5rem', height: '1.5rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                            onClick={() => closeVoucher()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to First Record"
                                            reactIcon={BiArrowToLeft}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => buttonClick}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Previous Record"
                                            reactIcon={BiLeftArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={previousVoucher}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Save Changes"
                                            reactIcon={FaRegSave}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => onSaveChanges()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Next Record"
                                            reactIcon={BiRightArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={nextVoucher}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Last Record"
                                            reactIcon={BiArrowToRight}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={moveToLastVoucher}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Prepare Multiple Checks"
                                            reactIcon={FaMoneyCheckAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => chooseVouchers()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Write Check for AP Voucher"
                                            reactIcon={GiQuillInk}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => handleWriteCheck()}
                                        />
                                        <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Reprint Check for Voucher"
                                            reactIcon={FaPrint}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => window.print()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Void an AP Check"
                                            reactIcon={FaRegFileExcel}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => voidCheck()}
                                        />
                                        <Button
                                            className="blue-hover-button"
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            onClick={() => addVendorInvoices()}
                                            title="Add Invoice"
                                            reactIcon={FaFileInvoiceDollar}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2.2rem', height: '2.2rem', verticalAlign: 'center'}}
                                        />
                                        {/*<Button
                                            className="blue-hover-button"
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            onClick={() => buttonClick}
                                            title="Exit Form"
                                            reactIcon={IoMdExit}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2.2rem', height: '2.2rem', verticalAlign: 'center'}}
                                        />*/}
                                    </div>
                                    <div className="form-row" style={{ marginTop: '1rem' }}>
                                        <RHFInputBox
                                            label="Vendor No."
                                            name={`currentVoucherMaintenanceForm.vendorId`}
                                            type="text"
                                            defaultVal={currentVoucherMaintenanceForm?.vendorId + ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', background: '#d5f7f5' }}
                                            bodyStyle={{ width: '16%', marginLeft: '.5rem' }}
                                            onDoubleClick={() => findVendor(false)}
                                            readOnly={true}
                                        />
                                        <RHFInputBox
                                            label="Vendor Name"
                                            name={`currentVoucherMaintenanceForm.vendorName`}
                                            type="text"
                                            defaultVal={currentVoucherMaintenanceForm?.vendorName + ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            label="Voucher No."
                                            name={`currentVoucherMaintenanceForm.voucherNumber`}
                                            type="number"
                                            defaultVal={currentVoucherMaintenanceForm?.voucherId + ''}
                                            register={register}
                                            errors={errors}
                                            bodyStyle={{ width: '16%' }}
                                            disabled={true}
                                        />
                                        <RHFInputBox
                                            label="Invoice Date"
                                            name={`currentVoucherMaintenanceForm.invoiceDate`}
                                            type="date"
                                            defaultVal={`${moment(currentVoucherMaintenanceForm?.invoiceDate).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%' }}
                                            disabled={!newVoucher}
                                        />
                                        <RHFInputBox
                                            label="Due Date"
                                            name={`currentVoucherMaintenanceForm.dueDate`}
                                            type="date"
                                            defaultVal={`${moment(currentVoucherMaintenanceForm?.dueDate).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%' }}
                                            disabled={false}
                                        />
                                        <RHFInputBox
                                            label="Close Date"
                                            name={`currentVoucherMaintenanceForm.closeDate`}
                                            type="date"
                                            defaultVal={`${moment(currentVoucherMaintenanceForm?.closeDate).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%' }}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Vendor Invoice"
                                            name={`currentVoucherMaintenanceForm.vendorInvoice`}
                                            type="text"
                                            defaultVal={vendorInvoiceFieldContent}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', background: '#d5f7f5' }}
                                            bodyStyle={{ width: '13%', marginLeft: '.5rem' }}
                                            onDoubleClick={() => addVendorInvoices()}
                                            readOnly={true}
                                        />
                                        <RHFInputBox
                                            label="Voucher Amount"
                                            name={`currentVoucherMaintenanceForm.voucherAmount`}
                                            type="number"
                                            defaultVal={invoiceAmount.toString()}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '13%' }}
                                        />
                                        <RHFInputBox
                                            label="Invoice Amount"
                                            name={`currentVoucherMaintenanceForm.invoiceAmount`}
                                            type="number"
                                            defaultVal={invoiceAmount.toString()}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '13%'}}
                                        />
                                        <RHFInputBox
                                            label="Description"
                                            name={`currentVoucherMaintenanceForm.description`}
                                            defaultVal={currentVoucherMaintenanceForm?.description}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '25%' }}
                                        />
                                        <RHFCheckbox
                                            label="Voucher Void"
                                            style={{verticalAlign: 'middle'}}
                                            name="currentVoucherMaintenanceForm.isVoucherVoid"
                                            checked={currentVoucherMaintenanceForm?.isVoucherVoid}
                                            register={register}
                                            bodyStyle={{ width: '16%', marginTop: '.5rem' }}
                                            errors={errors}
                                        />
                                        <RHFCheckbox
                                            label="Check Void?"
                                            style={{verticalAlign: 'middle'}}
                                            name="currentVoucherMaintenanceForm.isCheckVoid"
                                            checked={currentVoucherMaintenanceForm?.isCheckVoid}
                                            register={register}
                                            bodyStyle={{ width: '16%', marginTop: '.5rem' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Reoccur No."
                                            name={`currentVoucherMaintenanceForm.reoccurNumber`}
                                            type="number"
                                            defaultVal={currentVoucherMaintenanceForm?.reoccurNumber + ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%' }}
                                        />
                                        <RHFInputBox
                                            label="Payment No."
                                            name={`currentVoucherMaintenanceForm.paymentNumber`}
                                            type="number"
                                            defaultVal={currentVoucherMaintenanceForm?.paymentNumber + ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%' }}
                                        />
                                        <RHFInputBox
                                            label="Check No."
                                            name={`currentVoucherMaintenanceForm.checkNumber`}
                                            type="number"
                                            defaultVal={currentVoucherMaintenanceForm?.checkNumber + ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            label="Check Date"
                                            name={`currentVoucherMaintenanceForm.checkDate`}
                                            type="date"
                                            defaultVal={`${moment(currentVoucherMaintenanceForm?.checkDate).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%' }}
                                            disabled={true}
                                        />
                                        <RHFInputBox
                                            label="Date Voided"
                                            name={`currentVoucherMaintenanceForm.dateVoucherVoided`}
                                            type="date"
                                            defaultVal={`${moment(currentVoucherMaintenanceForm?.dateVoucherVoided).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%' }}
                                            disabled={true}
                                        />
                                        <RHFInputBox
                                            label="Date Voided"
                                            name={`currentVoucherMaintenanceForm.dateCheckVoided`}
                                            type="date"
                                            defaultVal={`${moment(currentVoucherMaintenanceForm?.dateCheckVoided).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '16%' }}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                    <Page.Section width={4}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle="Account Information">
                                <div style={{ padding: '.5rem' }}>
                                    <div style={{ overflowY: 'scroll', height: '21.4rem' }}>
                                        {displayAccountInfo()}
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page className="dlc-maxer-width">
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel>
                                <div className="form-row" style={{ marginBottom: '0' }}>
                                    <div style={{ textAlign: 'center', overflowY: 'scroll' }}>
                                        {voucherAccounts && displayVoucherAccounts()}
                                        <hr style={{margin: '1rem 0'}}/>
                                        {displayTotal()}
                                    </div>
                                </div>
                                <label id="BillingCodeError" style={{display: 'none', color: 'red'}}>Test</label>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page className="dlc-maxer-width">
                    <Page.Section width={6}>
                        <Panel backgroundColor="#D3D3D3">
                        <Panel panelTitle={'A/P Voucher Receipts'}>
                                <div>
                                    <div className="tiny-panel" style={{ overflowY: 'scroll' }}>
                                        <ReceiptDocs
                                            showDialog={showDialog}
                                            hideDialog={hideDialog}
                                            hasOwnership={false}
                                            userId={2}
                                        />
                                    </div>
                                    <div style={{ textAlign: 'center', overflowY: 'scroll' }}>
                                        {displayLegacyVoucherReceipts()}
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                    <Page.Section width={6}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={'A/P Charge Individuals'}>
                                <div style={{ width: '100%' }}>
                                    <div className="tiny-panel" style={{textAlign: 'center', overflowY: 'scroll'}}>
                                        <Button
                                            className="blue-hover-button"
                                            style={{ height: '3rem', justifyContent: 'center'}}
                                            text={'Add Person'}
                                            onClick={() => findPerson()}
                                        />
                                        {chargeIndividuals && displayChargeIndividuals()}
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
            </form>
            <FindPersonDialog 
                dialogName={DialogList.FIND_PERSON} 
                hideDialog={hideDialog}
                handleSelectedPerson={handleSelectedPerson}
                populatePersonList={getAllChargeIndividuals}
                personList={allChargeIndividuals}
            />
            <FindVendorDialog
                onCancel={() => onCancel()}
                dialogName={DialogList.FIND_VENDOR}
                hideDialog={hideDialogEx}
                incrementVendors={incrementVendors}
                vendors={vendors?.items}
                showAddVendorDialog={showAddVendorDialog}
                setSelectedVendor={setSelectedVendorIndex}
                resetVendorSearchOptions={resetVendorSearchOptions}
                setVendorSearchTerm={setVendorSearchTerm}
            />
            <AddVendorExDialog
                dialogName={DialogList.ADD_VENDOR_EX}
                hideDialog={hideAddVendorDialog}
                states={[{ name: 'Oklahoma', abbreviation: 'OK'}]}
                termDescriptions={[{ value: 'Net 15', label: '15' }]}
                createVendor={addVendor}
            />
            {(selectedVendor || addingJustInvoices) && voucherInvoices && <AddVendorInvoicesDialog
                setVoucherInvoices={setVoucherInvoices}
                newVoucher={newVoucher}
                onCancel={onCancelAddVendorInvoiceDialog}
                dialogName={DialogList.ADD_VENDOR_INVOICES}
                hideDialog={hideAddVendorInvoiceDialog}
                invoices={!newVoucher ? voucherInvoices : []}
                onCreateVoucher={clearVoucherAccounts}
                onCreateInvoice={addVendorInvoice}
                vendor={!!selectedVendor ?
                    selectedVendor : (addingJustInvoices ?
                    ({ vendorNumber: vouchers?.items[voucherIndex]?.vendorNumber, vendorName: vouchers?.items[voucherIndex]?.vendorName} as Vendor) : undefined)}
                voucherNumber={vouchers?.items?.length > 0 ? vouchers?.items[voucherIndex]?.voucherNumber : 0}
                onDeleteInvoice={removeVendorInvoice}
            />}
            <DefineBudgetCategoryDialog 
                dialogName={DialogList.DEFINE_BUDGET_CATEGORY} 
                hideDialog={hideDialog}
                handleCategories={handleCategories}
                selectedExpense={undefined}
            />
            <WarningDialog 
                dialogName={DialogList.WARNING} 
                hideDialog={hideDialog}
                label={!!voidingVoucher ? 'Void voucher No ' +  vouchers?.items[voucherIndex]?.voucherNumber + '?' : ''}
                handleConfirm={!voidingVoucher ? handleConfirmRemovePerson : handleConfirmVoidVoucher}
            />
            <ReportOptionsDialog 
                dialogName={DialogList.REPORT_OPTIONS} 
                hideDialog={hideDialog}
                handleReport={handleReport}
                showDialog={showDialog}
            />
            <FindAvailableAccountsDialog
                cancelClicked={onCancel}
                dialogName={DialogList.FIND_AVAILABLE_ACCOUNTS} 
                hideDialog={hideFindLedgerAccountDialog}
                handleOKClicked={handleFindLedgerAccountOKClicked}
            />
            <ChooseVouchersDialog 
                dialogName={DialogList.CHOOSE_VOUCHERS_TO_PAY} 
                hideDialog={hideDialog}
                handleSelectedVouchers={handleSelectedVouchers}
            />
            <ExcelFileDialog
                dialogName={DialogList.EXCEL_FILE}
                hideDialog={hideDialog}
            />
            <EnterCheckNumberDialog 
                dialogName={DialogList.ENTER_CHECK_NUMBER} 
                hideDialog={hideDialog}
                handleReport={handleReport}
                showDialog={showDialog}
                setCheckNumber={setVoucherCheckNumber}
                setCheckDate={setVoucherCheckDate}
            />
            <CreateCheckWarningDialog 
                dialogName={DialogList.CREATE_CHECK_WARNING} 
                hideDialog={hideDialog}
                handleConfirm={handleConfirmCreateCheck}
                showDialog={showDialog}
            />
            <VoidVoucherDialog 
                dialogName={DialogList.VOID_VOUCHER}
                hideDialog={hideDialog}
                handleVoid={voidVoucher}
                showDialog={showDialog} 
                voidType={voidType} 
                checkNumber={vouchers?.items[voucherIndex]?.checkNumber} 
                voucherNumber={Number(vouchers?.items[voucherIndex]?.voucherNumber)}            
            />
            <OutputDestinationDialog 
                dialogName={DialogList.OUTPUT_DESTINATION} 
                hideDialog={hideDialog}
                handleDownload={handleDownload}
            />
        </div>
    );
};

export default VouchersPage;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/pages/VouchersPage.tsx